import type { CreateReferrerDto } from '@api/btlApplicationForm/types';
import type { ExistingFirmResponse } from '@api/firm/firm.types';
import type { Referrer } from '@api/user/types';
import { isValidGbPhoneNumber } from '@utils/gbPhoneNumber';
import { isStrideUpInternalFirm } from '@utils/strideUpInternalFirm';

export function buildIntroducerPayloadFromFormValues(
  values: Record<string, unknown>,
  firm: ExistingFirmResponse,
): CreateReferrerDto | undefined {
  if (!isStrideUpInternalFirm(firm) || values.hasIntroducer !== 'true') {
    return undefined;
  }

  const firstName = String(values.introducerFirstName ?? '').trim();
  const lastName = String(values.introducerLastName ?? '').trim();
  const emailAddress = String(values.introducerEmail ?? '').trim();
  const phoneNumber = String(values.introducerPhoneNumber ?? '').trim();

  if (!firstName || !lastName || !emailAddress || !phoneNumber || !isValidGbPhoneNumber(phoneNumber)) {
    return undefined;
  }

  return {
    firstName,
    lastName,
    emailAddress,
    phoneNumber,
  };
}

export function mapIntroducerFormValuesFromReferrer(referrer: Referrer): Record<string, string> {
  return {
    hasIntroducer: 'true',
    introducerFirstName: referrer.firstName,
    introducerLastName: referrer.lastName,
    introducerEmail: referrer.emailAddress,
    introducerPhoneNumber: referrer.phoneNumber,
  };
}

export function mapIntroducerFormValuesFromCaseReferrer(
  caseReferrerId: string | undefined,
  brokerReferrerId: string | undefined,
  introducerReferrer?: Referrer | null,
): Record<string, string> | undefined {
  if (!caseReferrerId || !brokerReferrerId || caseReferrerId === brokerReferrerId) {
    return { hasIntroducer: 'false' };
  }

  if (!introducerReferrer) {
    return { hasIntroducer: 'true' };
  }

  return mapIntroducerFormValuesFromReferrer(introducerReferrer);
}
